var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',[_c('section',{attrs:{"id":"main"}},[_c('footer',[_vm._v(" Codigo del footer ")])])])}]

export { render, staticRenderFns }